export const CouriersCarsColumns = [
    {
        name: 'Компания',
        key: 'company'
    },
    {
        name: 'Гос. номер',
        key: 'number',
    },
    {
        name: 'Тип',
        key: 'vehicle_type_name'
    },
    {
        name: 'Модель',
        key: 'model',
    },
    {
        name: 'Кубатура',
        key: 'cubature'
    },
    {
        name: 'Грузоподъемность',
        key: 'ftl_car_type_name'
    },
    {
        name: 'Код 1С',
        key: 'code_1C'
    },
    {
        name: 'Статус',
        key: 'status'
    }
]
